export default __webpack_public_path__ + "static/media/bear_pic_3_mobile.de3fd562.png";